<template>
  <div class="avatar" :style="avatarStyle">
    <img v-if="src" :src="src" alt="avatar" />
    <slot v-else></slot>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  src: {
    type: String,
    default: null,
  },
  size: {
    type: String,
    default: '48px',
  },
  color: {
    type: String,
    default: '#f5f5f5',
  },
});

const avatarStyle = computed(() => ({
  width: props.size,
  height: props.size,
  "background-color": props.color,
}));

</script>

<style scoped>
.avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  //background-color: #f5f5f5; /* Default background color */
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
